import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton } from "material-ui"
import FinddDatePicker from "../../common/FinddDatePicker"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import strings from "../../../localization/strings"
import { blueGrey500 } from "material-ui/styles/colors"
import moment from "moment"
import { IDate, IPayrollPayCalendar, EExceptionType, IUserFilter } from "../../../models"
import * as reportAction from "../../../actions/ReportAction"
import * as payrollHelper from "../../../helpers/payrollHelper"
import * as timecardHelper from "../../../helpers/timecardHelper"

interface IProps {
    referenceDate: IDate
    selectedPayrollPayCalendar: IPayrollPayCalendar
    userFilter: IUserFilter
    handleClose(): void

    // timecard filters
    filterByDefaultHierarchy: boolean
    filterDirectReportsOnly: boolean
    filterByPunchHierarchy: boolean
    filterByException: boolean
    filterExceptions: EExceptionType[]

    /**
     * If you decide you need job-based filtering,
     * you could optionally include jobId here
     * (currently not supported by the new endpoint)
     */
    jobId?: string
}

interface IState {
    startDate: IDate
    endDate: IDate
}

export default class BiometricLocationExceptionsReportDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const timecardDates = timecardHelper.getTimecardDateByPayrollPayCalendar(props.referenceDate, props.selectedPayrollPayCalendar)
        this.state = {
            startDate: moment(timecardDates.StartDate).format(),
            endDate: moment(timecardDates.EndDate).format(),
        }
        autobind(this)
    }

    /**
     * Called when the user changes the 'start date'.
     */
    onStartDateChange = (e: any, value: IDate) => {
        this.setState({ startDate: moment(value).format("YYYY-MM-DD")})
    }

    /**
     * Called when the user changes the 'end date'.
     */
    onEndDateChange = (e: any, value: IDate) => {
        this.setState({ endDate: moment(value).format("YYYY-MM-DD") })
    }

    /**
     * Called when the user clicks the 'Download' button.
     * We close the dialog and then call the report endpoint 
     * using the relevant action from 'reportAction'.
     */
    handleRequestSave() {
        this.props.handleClose()

        // Gather pay group IDs from the selected pay calendar
        const payGroupIds = payrollHelper.getPayGroupIdsByPayrollPayCalendar(this.props.selectedPayrollPayCalendar)

        // Call our new endpoint logic
        reportAction.downloadBiometricLocationExceptionsReport(
            AuthenticationStore.getCookieAccountId(),
            this.state.startDate as string,
		    this.state.endDate as string,
            HierarchySettingsStore.getGlobalLevelItemFilterId(),
            payGroupIds,
            this.props.userFilter,
            this.props.filterByDefaultHierarchy,
            this.props.filterDirectReportsOnly,
            this.props.filterByPunchHierarchy,
            this.props.filterByException,
            this.props.filterExceptions
        )
    }

    render() {
        return (
            <Dialog
                open
                title={strings.Biometric_Location_Exceptions_Report}
                actions={[
                    <FlatButton
                        data-intercom-target={"Timecards-Reports-Btn-CloseBiometricLocationExceptionsReportDialog"}
                        key="cancel"
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    <FlatButton
                        data-intercom-target={"Timecards-Reports-Btn-DownloadBiometricLocationExceptionsReport"}
                        key="download"
                        label={strings.Download}
                        primary
                        onTouchTap={this.handleRequestSave}
                    />
                ]}
            >
                {/* START DATE PICKER */}
                <FinddDatePicker
                    value={this.state.startDate}
                    onChange={this.onStartDateChange}
                    floatingLabelText={strings.Start_Date}
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                />

                {/* END DATE PICKER */}
                <FinddDatePicker
                    value={this.state.endDate}
                    onChange={this.onEndDateChange}
                    floatingLabelText={strings.End_Date}
                    cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                    firstDayOfWeek={0}
                />
            </Dialog>
        )
    }
}
